import { Component } from '@angular/core';

@Component({
  selector: 'integrations-connect-element',
  templateUrl: './connect-element.component.html',
  standalone: false,
})
export class ConnectElementComponent {}
